import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SchedulerOverview } from '../../models/scheduler';

@Injectable({
  providedIn: 'root'
})
export class SchedulersOverviewService {
  constructor(protected http: HttpClient) {}

  public getSchedulers(nocache?: boolean): Observable<SchedulerOverview[]> {
    const url = 'json/quartz/job-history';
    const headers = {
      maxAge: nocache ? '-1' : '300'
    };

    return this.http.get<SchedulerOverview[]>(url, { headers });
  }
}
